import * as React from 'react';
const SvgArrowClockwisePlay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M20.71 4.05c.1.05.17.13.22.22h.02c.05.11.05.25.05.53v2.4c0 1 0 2.04-.11 2.25-.05.1-.12.19-.2.27-.07.07-.15.12-.24.17-.21.11-1.248.11-2.247.11h-2.397c-.28 0-.42 0-.53-.05a.52.52 0 0 1-.228-.237c-.017-.032-.031-.06-.031-.103-.02-.1-.02-.22-.02-.41v-.4c0-.28 0-.42.05-.53.05-.1.13-.17.22-.22.11-.05.25-.05.529-.05h1.948l-.107-.13q-.045-.059-.103-.13A6.99 6.99 0 0 0 11.99 5a6.99 6.99 0 0 0-6.992 7c0 3.87 3.126 7 6.992 7 1.638 0 3.146-.57 4.345-1.52.24-.2.36-.29.47-.32.11-.02.19-.02.29.02.1.03.2.13.399.33l.28.28c.2.2.29.3.33.42.03.11.03.23-.01.33-.05.11-.15.2-.34.36A8.9 8.9 0 0 1 11.99 21C7.026 21 3 16.97 3 12s4.026-9 9-9c2.837 0 5.344 1.33 6.992 3.38V4.8c0-.28 0-.42.05-.53.05-.1.13-.17.22-.22a.55.55 0 0 1 .25-.05h.669c.28 0 .42 0 .53.05"
    />
    <path
      fill="currentColor"
      d="M9 14.975c0 .465 0 .7.108.83a.53.53 0 0 0 .388.194c.177.01.393-.115.818-.37l5.026-2.964c.372-.22.555-.33.62-.47a.47.47 0 0 0 0-.38c-.065-.14-.248-.25-.62-.47L10.314 8.37c-.425-.254-.64-.38-.818-.37a.6.6 0 0 0-.248.076.45.45 0 0 0-.14.12C9 8.326 9 8.56 9 9.026z"
    />
  </svg>
);
export default SvgArrowClockwisePlay;
